import React, { useState } from 'react';
import './Contact.css';
import Header from './Header';
import Footer from './Footer';
import api from './Api';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: '',
        mobileNumber:''
    });

    const [status, setStatus] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("loading");

        try {
            const response = await api.post("/contact",formData);

            if (response?.id) {
                setStatus("success");
                setFormData({ name: '', email: '', message: '' , mobileNumber:''});
            } else {
                setStatus("error");
            }
        } catch (error) {
            console.error("Error submitting contact form:", error);
            setStatus("error");
        }
    };

    return (
        <>
            <Header />
            <main className="contact-container">
                <h1 className="contact-title">Get in Touch</h1>
                <p className="contact-intro">
                    Have a question, suggestion, or just want to say hello?  
                    Fill out the form below and we’ll get back to you shortly.
                </p>

                <form className="contact-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="form-label" htmlFor="name">Name</label>
                        <input
                            className="form-input"
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>
                     <div className="form-group">
                        <label className="form-label" htmlFor="name">Mobile Number</label>
                        <input
                            className="form-input"
                            type="text"
                            id="mobileNumber"
                            name="mobileNumber"
                            value={formData.mobileNumber}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label" htmlFor="email">Email</label>
                        <input
                            className="form-input"
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label" htmlFor="message">Message</label>
                        <textarea
                            className="form-textarea"
                            id="message"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                        ></textarea>
                    </div>
                    <button className="form-button" type="submit" disabled={status === "loading"}>
                        {status === "loading" ? "Sending..." : "Submit"}
                    </button>
                </form>

                {status === "success" && (
                    <p className="form-success">✅ Thank you! Your message has been sent successfully.</p>
                )}
                {status === "error" && (
                    <p className="form-error">❌ Oops! Something went wrong. Please try again later.</p>
                )}
            </main>
            <Footer />
        </>
    );
};

export default Contact;
